import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang/translate';
import ArrowIcon from '@tradera/blueprint/theme/icons2/arrow-down.svg?jsx';
import { Button } from 'tradera-components/atoms/button/button';

export const ShowMoreButton = ({ children, onClick }) => {
    const { t } = useTranslator();
    return (
        <Button
            theme="dark"
            outline
            size="sm"
            fluid
            iconFixed
            className="my-2 w-100"
            onClick={onClick}>
            {children ? children : t('treeNavigation_showMore')}
            <ArrowIcon className="icon icon-xs ml-3" />
        </Button>
    );
};

ShowMoreButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node
};
